import { createNode } from '@glueapp/graph-types';

export const HyperbolicCosine = createNode({
    id: 'Hyperbolic Cosine',
    name: 'Hyperbolic Cosine',
    description: 'Gives the hyperbolic cosine of the value',
    aiDescription:
        'Computes the hyperbolic cosine of a number. Connect a value to the "Value" input port; the "Result" output port provides the hyperbolic cosine.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.cosh(input.inPorts.Value) } };
    },
});
